const getLoading = (state) => state.loading;

export const isCreateCommentsLoading = (state) => getLoading(state).createComments || false;

export const isDataviewLoading = (state) => getLoading(state).dataview || false;
